import { Directive, inject, input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthService } from './auth.service';
import { UserGroup } from './user';

export type Role = 'admin' | 'beheerder' | 'monitor' | 'kind' | 'volunteer-tablet';

const roleGroups: Record<Role, readonly UserGroup[]> = {
  admin: [UserGroup.ADMIN],
  beheerder: [UserGroup.BEHEERDER, UserGroup.ADMIN],
  monitor: [UserGroup.MONITOR, UserGroup.BEHEERDER, UserGroup.ADMIN],
  kind: [UserGroup.KIND],
  'volunteer-tablet': [UserGroup.VOLUNTEERTABLET],
};

@Directive({ selector: '[appIfRole]' })
export class IfRoleDirective implements OnInit {
  readonly appIfRole = input.required<Role>();

  private visible = false;
  private readonly viewContainerRef = inject(ViewContainerRef);
  private readonly templateRef = inject<TemplateRef<unknown>>(TemplateRef);
  private readonly authService = inject(AuthService);

  ngOnInit(): void {
    const groups = roleGroups[this.appIfRole()];
    this.authService.getCurrentUser().subscribe((user) => {
      if (!user.hasOneOfGroups(groups)) {
        this.visible = false;
        this.viewContainerRef.clear();
        return;
      }
      if (!this.visible) {
        this.visible = true;
        this.viewContainerRef.createEmbeddedView(this.templateRef);
      }
    });
  }
}
